import {
  BookWidgetFields,
  TripTypeOptions
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';

export const updateTripTypeFieldFromRecentSearch = (
  retrieveSearchData: RetrieveSearchData,
  bookWidgetFields: BookWidgetFields,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig
) => {
  let updatedBookWidgetFields = { ...bookWidgetFields };

  if (!bookWidgetFieldsMasterConfig.tripTypesField?.disable) {
    let selectedTripType: TripTypeOptions = retrieveSearchData.selectTripType;

    const dropdownOptions = [
      ...updatedBookWidgetFields.tripTypesField.dropdownOptions.map((data) => ({
        ...data,
        selected: false
      }))
    ];

    const indexOfSelectedTripType = dropdownOptions.findIndex(
      ({ value }) => value === selectedTripType
    );

    if (indexOfSelectedTripType === -1) {
      selectedTripType = dropdownOptions[0].value as TripTypeOptions;
      dropdownOptions[0].selected = true;
    } else {
      dropdownOptions[indexOfSelectedTripType].selected = true;
    }

    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      tripTypesField: {
        ...updatedBookWidgetFields.tripTypesField,
        selectedTripType,
        dropdownOptions,
        disable: false
      }
    };
  }

  return updatedBookWidgetFields;
};
